<template>
    <div v-loading="loading">
        <div class="m-personal-container">
            <div class="m-personal g-wrapper g-clearfix">
                <!-- personal menu -->
                <div class="personal_left" id="personalMenu" module="menu-user">
                    <dl>
                        <dt>个人中心</dt>
                        <dd id="order_l1" :class="pageType == 0 ? 'ons' : ''">
                            <a href="/orderlist" class="per_l_1">我的订单</a>
                        </dd>
                        <dd id="order_l1" :class="pageType == 1 ? 'ons' : ''">
                            <a href="/InquiryOrderList" class="per_l_1">我的询价单</a>
                        </dd>
                    </dl>
                </div>
                <!-- personal menu/END -->

                <div class="personal-main">
                    <table class="m-order-list" v-if="inquiryOrderList.length > 0">
                        <thead>
                            <tr>
                                <th class="goods">询价单信息</th>
                                <!-- <th class="total">金额</th> -->
                                <th class="status">状态</th>
                                <!-- <th class="handle">操作</th> -->
                            </tr>
                        </thead>
                        <tbody id="orderList" class="orderList" v-for="(item, key) in inquiryOrderList" :key="key">
                            <tr class="order-header">
                                <td colspan="4">
                                    <!-- <span class="data-item">订单编号：{{ item.OrderNo }}</span> -->
                                    <span class="data-item"
                                        >询价时间：{{ moment(item.CreateTime).format('YYYY[年]MM[月]DD HH[:]mm[:]ss') }}</span
                                    >
                                </td>
                            </tr>
                            <tr class="order-detail">
                                <td>
                                    <ul class="order-goods">
                                        <li v-for="(_item, _key) in item.Detail" :key="_key" style="margin-bottom: 20px;">
                                            <div class="m-goods-item" style="display: flex; align-items: center;">
                                                <a :href="'/procInfo?sku=' + _item.SKU" target="_blank" class="pic">
                                                    <img :src="'http://mallmgr.cesseon.com/res/exhPic/' + _item.PicName" />
                                                </a>
                                                <div class="info">
                                                    <p class="title" style="height: 20px;">
                                                        <a :href="'/procInfo?sku=' + _item.SKU" target="_blank">{{
                                                            _item.SKUName +
                                                                '&nbsp;&nbsp;' +
                                                                (_item.CustSKU ? '客户料号：' + _item.CustSKU : '')
                                                        }}</a>
                                                    </p>
                                                    <div style="display: flex; justify-content: space-between;">
                                                        <div>
                                                            <p style="margin: 0;">
                                                                {{ _item.Tag + '&nbsp;&nbsp;&nbsp;' + _item.Unit }}
                                                            </p>
                                                            <strong class="g-highlight" v-if="item.State != '0' && _item.DiscountPrice">
                                                                ￥ {{ (_item.DiscountPrice / 100).toFixed(2) }}
                                                            </strong>
                                                            <strong class="g-highlight" v-else>
                                                                &nbsp;
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <p style="text-align: left; color:red; padding-left: 80px;">
                                        {{ item.Remark ? '备注：' + item.Remark : '' }}
                                    </p>
                                </td>
                                <td>
                                    <p v-if="item.State == '1'">{{ (item.CheckerName ? item.CheckerName : '') + item.StateName }}</p>
                                    <p v-else>{{ item.StateName }}</p>
                                    <!-- <el-button type="info" v-if="item.State == '1'" @click="CancelOrder(item.OrderHedID)"
                                        >取消订单</el-button
                                    > -->
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="m-pagination noselect">
                        <el-pagination
                            background
                            :page-size="pageSize"
                            :pager-count="11"
                            layout="prev, pager, next"
                            :total="pageTotal"
                            @current-change="drop($event)"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GlobalFun } from '@/common/utils';
import { InquiryOrderListApi } from '../common/api';
import $ from 'jquery';
export default {
    name: 'InquiryOrderList',
    data() {
        return {
            loading: false,
            userinfo: null,
            inquiryOrderList: [],
            orderListData: [],
            moment: require('moment'),

            //分页信息
            pageSize: 10,
            pageIndex: 0,
            pageCount: 11,
            innerPageCount: 1,
            pageTotal: 0,
            pageType: 1 //0我的订单 1询价单
        };
    },
    methods: {
        CancelOrder(orderid) {
            this.$confirm('是否取消订单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                OrderApi.CancelOrder(orderid).then(async res => {
                    this.orderList = await this.getOrderList();
                    this.orderListData = this.orderList.Data;
                    for (let i of this.orderList.Data) {
                        for (let item of i.Info) {
                            this.sumPrice += +((item.DiscountUnitPrice / 100).toFixed(2) * item.Count).toFixed(2);
                        }
                    }
                });
            });
        },

        async drop(e) {
            this.loading = true;
            this.pageIndex = e - 1;
            this.orderList = await this.getOrderList();
            this.orderListData = this.orderList;
            for (let i of this.orderList.Data) {
                for (let item of i.Info) {
                    this.sumPrice += +((item.DiscountUnitPrice / 100).toFixed(2) * item.Count).toFixed(2);
                }
            }
            this.loading = false;
        },
        getOrderList() {
            return new Promise(result => {
                OrderApi.GetOrderListInPortal({
                    pageSize: this.pageSize,
                    pageIndex: this.pageIndex
                })
                    .then(res => {
                        console.log(res);
                        this.pageTotal = res.Data.TotalCount;
                        this.pageCount = Math.ceil(this.pageTotal / this.pageSize);
                        result(res);
                    })
                    .catch(err => {
                        result([]);
                    });
            });
        }
    },
    async created() {
        this.userinfo = await GlobalFun.getCookie('UserInfo');
        if (!this.userinfo) {
            let url = window.location.pathname + window.location.search;
            this.$router.push({
                path: '/login',
                query: {
                    url: url
                }
            });
        }
        this.inquiryOrderList = await InquiryOrderListApi.GetInquirySheetList();
        // this.orderList = await this.getOrderList();
        // this.orderListData = this.orderList.Data;
        // for (let i of this.orderList.Data) {
        //     for (let item of i.Info) {
        //         this.sumPrice += +((item.DiscountUnitPrice / 100).toFixed(2) * item.Count).toFixed(2);
        //     }
        // }
    }
};
</script>

<style>
@import url('../assets/css/orderlist.css');

.noselect {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Chrome/Safari/Opera */
    -khtml-user-select: none;
    /* Konqueror */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
    color: #fff;
    background-color: #f03a58;
}

.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: #fff;
    background-color: #f03a58;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: red;
}

.disabled {
    cursor: not-allowed;
}
</style>
